import { map } from "rxjs/operators";

import { axiosRequest } from "@/utils/utils-axios";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { type ResponseData } from "@/types/app";
import type { ProjectContent } from "@/types/content";
import type {
  CreateProjectDto,
  UpdateProjectDto,
  DeleteProjectDto,
  AssignUsersToProjectDto,
  UnassignUsersFromProjectDto,
  UpdateUserRoleDto,
  ProjectUserAssignment,
  TransferOwnershipDto,
  CloneProjectDto,
} from "@/types/dto";
export const GetProjectByUserId = (
  page: number,
  limit: number,
  search: string,
  sort: string
) => {
  return axiosRequest({
    url: "/api/projects/get-projects-by-user-id",
    method: "get",
    params: {
      page,
      limit,
      search,
      sort,
    },
  }).pipe(
    map(
      (response) =>
        response.data as ResponseData<{
          total: number;
          data: ProjectContent[];
          totalPages: number;
        }>
    ),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const GetProjectById = (projectId: string) => {
  return axiosRequest({
    url: `/api/projects/get-project-by-id`,
    method: "get",
    params: {
      projectId,
    },
  }).pipe(
    map((response) => response.data as ResponseData<ProjectContent>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const GetProjectUsers = (projectId: string) => {
  return axiosRequest({
    url: `/api/projects/get-users-in-project`,
    method: "get",
    params: {
      projectId,
    },
  }).pipe(
    map((response) => response.data as ResponseData<ProjectUserAssignment[]>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const CreateProject = (dto: CreateProjectDto) => {
  return axiosRequest({
    url: "/api/projects/create",
    method: "post",
    data: dto,
  }).pipe(
    map((response) => response.data as ResponseData<ProjectContent>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const UpdateProject = (dto: UpdateProjectDto) => {
  return axiosRequest({
    url: `/api/projects/update-project`,
    method: "put",
    data: dto,
  }).pipe(
    map((response) => response.data as ResponseData<ProjectContent>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const DeleteProject = (dto: DeleteProjectDto) => {
  return axiosRequest({
    url: `/api/projects/delete-project`,
    method: "delete",
    data: dto,
  }).pipe(
    map((response) => response.data as ResponseData<ProjectContent>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const AssignUserToProject = (dto: AssignUsersToProjectDto) => {
  return axiosRequest({
    url: `/api/projects/assign-users-to-project`,
    method: "post",
    data: dto,
  }).pipe(
    map((response) => response.data as ResponseData<ProjectContent>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const UnassignUsersFromProject = (dto: UnassignUsersFromProjectDto) => {
  return axiosRequest({
    url: `/api/projects/unassign-users-from-project`,
    method: "post",
    data: dto,
  }).pipe(
    map((response) => response.data as ResponseData<unknown>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const UpdateUserRole = (dto: UpdateUserRoleDto) => {
  return axiosRequest({
    url: `/api/projects/update-user-role`,
    method: "patch",
    data: dto,
  }).pipe(
    map((response) => response.data as ResponseData<unknown>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const TransferOwnershipToUser = (dto: TransferOwnershipDto) => {
  return axiosRequest({
    url: `/api/projects/transfer-ownership`,
    method: "put",
    data: dto,
  }).pipe(
    map((response) => response.data as ResponseData<unknown>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const CloneProject = (dto: CloneProjectDto) => {
  return axiosRequest({
    url: `/api/projects/clone-project`,
    method: "post",
    data: dto,
  }).pipe(
    map((response) => response.data as ResponseData<ProjectContent>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};
